export default __webpack_public_path__ + "static/media/EuclidSquare-Light.62b29a70.woff";